import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { CommonBaseURl } from "../../src/Commonprovider/CommonProvider";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  setExport,
  setExportDetails,
  setExported,
  toggleExported,
} from "../Redux/Slices/CommonLocalRedux/CommonSliceStorage";
import Store from "../Redux/Store/Store";


import CryptoJS from 'crypto-js';

const key = CryptoJS.enc.Utf8.parse("YourSecretKey1234567890123456"); // 32 characters = 256-bit
const iv = CryptoJS.enc.Utf8.parse("InitializationVe"); // 16 characters = 128-bit

export const Logout = async (loginType) => {

  let UserId = sessionStorage.getItem("getuserid");
  var requestOptions = {
    method: "POST",
    body: JSON.stringify({
      UserID: UserId,
    }),
    headers: {
      "Content-type": "application/json; charset=UTF-8",
    },
  };
  const response = await fetch(
    `${CommonBaseURl}UpdateSessionNULL`,
    requestOptions
  );
  fetch(`${CommonBaseURl}UserLogNew?flag=out&userid=${UserId}`, {
    method: "GET",
    headers: {
      "Content-type": "application/json; charset=UTF-8",
    },
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.status == "success") {
        if (loginType == 'External') {
          localStorage.clear();
          sessionStorage.clear();
          window.location.replace("/externallogin");
        } else if (loginType == 'FC') {
          localStorage.clear();
          sessionStorage.clear();
          window.location.replace("/facelogin");
        }
        else {
          localStorage.clear();
          sessionStorage.clear();
          window.location.replace("/");
        }
      }
      else {
        alert('failed to logout!!')
      }
    })
};

export const Conversion = (val, type, rsIn, currency) => {
  val = Number(val);
  if (isNaN(val)) {
    return " "; // or handle the error case appropriately
  }
  if (type != null) {
    if (type.toUpperCase() === "B") {
      return (val * rsIn) / currency;
    } else if (type.toUpperCase() === "S") {
      return val / currency;
    } else {
      return val;
    }
  } else {
    return val;
  }
};

export const exportToExcel = async (
  LeftHeadMenu,
  PageName,
  CompanyName,
  rsIn,
  currency,
  rowData,
  Consolidated,
  tabName
) => {
  try {
    let ConsolidatedValue;
    if (Consolidated === "true") {
      ConsolidatedValue = "Consolidate";
    } else if (Consolidated === "false") {
      ConsolidatedValue = "Standalone";
    }
    const pageHeader = `${LeftHeadMenu} > ${PageName}  ${tabName ? `-(${tabName})` : ""
      } ${ConsolidatedValue === "" ? "" : `(${ConsolidatedValue})`
      } > ${CompanyName} (Curr. ${rsIn} In ${currency})`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(tabName ? tabName : PageName);

    // Define column headers
    const yearKeys = Object.keys(rowData[0] || {}).filter((key) =>
      /^\d+$/.test(key)
    );
    // .sort((a, b) => b - a); // Sort years in descending order
    const columns = [
      { header: "Year End", key: "DISPLAYNAME", width: 30 },
      ...yearKeys.map((year) => ({ header: year, key: year, width: 15 })),
    ];

    worksheet.columns = columns;

    // Add page header as a merged cell in the first row
    worksheet.mergeCells(1, 1, 1, columns.length); // Merge from A1 to the last column
    const headerCell = worksheet.getCell("A1");
    headerCell.value = pageHeader;
    headerCell.font = { bold: true, size: 14 };
    headerCell.alignment = {
      vertical: "middle",
      wrapText: true,
      horizontal: "left",
    };

    // Add column headers in the second row
    const headerRow = worksheet.getRow(2); // Row 2 for column headers
    headerRow.values = columns.map((col) => col.header); // Set headers
    headerRow.font = { bold: true }; // Make headers bold
    headerRow.alignment = { horizontal: "center" }; // Center-align headers
    headerRow.eachCell((cell) => {
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });

    // Populate rows with data
    rowData.forEach((item, index) => {
      const row = {
        DISPLAYNAME: item.DISPLAYNAME || "",
        ...yearKeys.reduce((acc, year) => {
          acc[year] =
            item[year] !== undefined && item[year] !== null ? item[year] : 0;
          return acc;
        }, {}),
      };

      // worksheet.addRow(row);

      const newRow = worksheet.addRow(row);

      const isBreakupData = item.innerBreakupData === true;

      newRow.eachCell((cell, colIndex) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFFFF" },
        };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
        if (item.BreakupType === "Y") {
          cell.font = { bold: true };
        }
        if (isBreakupData && colIndex === 2) {
          // Column 2 should be the DISPLAYNAME column
          cell.value = "          " + cell.value; // Prepend spaces to create a "margin"
        }
        if (!cell.value) {
          cell.value = cell.value || "-"; // Ensure every cell has a default value
        }
      });
    });

    worksheet.eachRow((row, rowIndex) => {
      if (rowIndex <= 2) return;

      row.eachCell((cell, colIndex) => {
        cell.alignment =
          colIndex > 2 ? { horizontal: "right" } : { horizontal: "left" };
      });
    });

    const lastRowNumber = worksheet.lastRow.number + 2;
    worksheet.mergeCells(lastRowNumber, 1, lastRowNumber, columns.length);
    const disclaimerCell = worksheet.getCell(`A${lastRowNumber}`);
    disclaimerCell.value = `Disclaimer: Capitaline Database has taken due care and caution in compilation of data. However, Capitaline Database makes no warranty that the service will meet all your requirements, the service will always be error-free, or the service will be uninterrupted timely, complete, error-free, or the results that may be obtained from the use of the service will be accurate.Use of data from Capitaline is permitted only to the licensee and its employees internal usage. The Licensee shall not use Capitaline or data from Capitaline or permit any third party to do so in order to provide data processing, advisory, or research services to third parties by way of trade or otherwise. The Licensee shall also not make the data available on a network that extends beyond the Licensee's premises. In the event of unauthorized use of Capitaline or data from Capitaline by the Licensee, Capital Market Publishers India Pvt. Ltd. will terminate the subscription immediately."`;
    disclaimerCell.font = { italic: true, size: 12 };
    disclaimerCell.alignment = {
      horizontal: "left",
      vertical: "top",
      wrapText: true,
    };
    disclaimerCell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };

    worksheet.getRow(lastRowNumber).height = 90;
    const buffer = await workbook.xlsx.writeBuffer();
    const fileSizeInBytes = buffer.byteLength;
    const fileSizeInKB = (fileSizeInBytes / 1024).toFixed(2);
    const fileSizeInMB = (fileSizeInBytes / (1024 * 1024)).toFixed(2);
    Store.dispatch(setExportDetails({ export: 1, size: fileSizeInKB }));
    Store.dispatch(toggleExported());
    const fileName = `${PageName}.xlsx`;
    saveAs(new Blob([buffer]), fileName);
    setTimeout(() => {
      Store.dispatch(setExportDetails({ export: 0, size: 0 }));
    }, 2000);
  } catch (error) {
    console.error("Error exporting Excel:", error);
  }
};

export const exportToExcelSingleBinding = async (
  LeftHeadMenu,
  PageName,
  CompanyName,
  rsIn,
  currency,
  rowData,
  Consolidated,
  columnDefs,
  tabName
) => {
  // console.log("rows",rowData)
  // debugger;
  try {
    let ConsolidatedValue;
    if (Consolidated === "true") {
      ConsolidatedValue = "Consolidate";
    } else if (Consolidated === "false") {
      ConsolidatedValue = "Standalone";
    } else {
      ConsolidatedValue = "";
    }

    const pageHeader = `${LeftHeadMenu} >> ${PageName} ${ConsolidatedValue === "" ? "" : `(${ConsolidatedValue})  >>`
      }${CompanyName} ${rsIn && currency ? `(Curr. ${rsIn} In ${currency})` : ""
      } ${tabName ? `${tabName}` : ""}`;
    // Create a new workbook
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(tabName ? tabName : PageName);

    // Define columns based on columnDefs
    const hasSrNo = columnDefs.some(
      (col) => col.headerName === "Sr. No." || col.field === "srno"
    );

    // Define columns, add Sr. No. column only if not already present
    // const columns = hasSrNo
    //     ? columnDefs.map((col) => ({
    //         header: col.headerName,
    //         key: col.field,
    //         width: Math.max(10, col.width / 7), // Adjust the divisor for better scaling
    //     }))
    //     : [
    //         { header: 'Sr. No.', key: 'srno', width: 10 }, // Fixed width for Sr. No.
    //         ...columnDefs.map((col) => ({
    //             header: col.headerName,
    //             key: col.field,
    //             width: Math.max(10, col.width / 7), // Adjust divisor or set a minimum width
    //         })),
    //     ];

    const columns = columnDefs.map((col) => {
      const maxContentLength = Math.max(
        col.headerName.length,
        ...rowData.map((row) => (row[col.field] || "").toString().length)
      );
      return {
        header: col.headerName,
        key: col.field,
        width: Math.max(10, maxContentLength + 2), // Minimum width of 10, with padding
      };
    });

    worksheet.columns = columns;

    // Merge header row
    worksheet.mergeCells(1, 1, 1, columns.length);
    const headerCell = worksheet.getCell("A1");
    headerCell.value = pageHeader;
    headerCell.font = { bold: true, size: 14 };
    headerCell.alignment = { horizontal: "left", vertical: "middle" };

    // Adding column headers
    const headerRow = worksheet.getRow(2);
    headerRow.values = columns.map((col) => col.header);
    headerRow.font = { bold: true };
    headerRow.alignment = { horizontal: "center" };
    headerRow.eachCell((cell) => {
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
      cell.alignment = {
        horizontal: "center",
        vertical: "middle",
        wrapText: true,
      };
    });

    // Adding data rows
    rowData.forEach((item, rowIndex) => {
      // const row = [
      //     rowIndex + 1, // Serial number column
      //     ...columns.slice(1).map((col) => {
      //         const colDef = columnDefs.find((def) => def.field === col.key);
      //         if (colDef && colDef.valueFormatter) {
      //             return colDef.valueFormatter({ value: item[col.key] });
      //         }
      //         return item[col.key] || "" // Default value if no formatter
      //     }),
      // ];

      const row = columns.map((col) => {
        const colDef = columnDefs.find((def) => def.field === col.key);
        if (colDef && colDef.valueFormatter) {
          return colDef.valueFormatter({
            value: item[col.key],
            data: item,
            colDef,
          });
        }
        return item[col.key] || "-"; // Default to "-"
      });
      // worksheet.addRow(row);
      const newRow = worksheet.addRow(row);

      const isBreakupData = item.innerBreakupData === true;

      newRow.eachCell((cell, colIndex) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFFFF" },
        };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };

        if (item.BreakupType === "Y") {
          cell.font = { bold: true };
        }
        if (isBreakupData && colIndex === 2) {
          // Column 2 should be the DISPLAYNAME column
          cell.value = "          " + cell.value;
        }

        const totalColumns = columns.length;
        for (let colIndex = 1; colIndex <= totalColumns; colIndex++) {
          const cell = newRow.getCell(colIndex);
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
          if (!cell.value) {
            cell.value = "-";
          }
        }
      });
    });

    // worksheet.eachRow((row, rowIndex) => {
    //     if (rowIndex <= 2) return; // Skip header rows
    //     row.eachCell((cell) => {
    //         cell.alignment = { horizontal: "left", vertical: 'middle', wrapText: true };
    //     });
    // });
    worksheet.eachRow((row, rowIndex) => {
      if (rowIndex <= 2) return; // Skip header rows

      row.eachCell((cell) => {
        cell.alignment = {
          horizontal: isNaN(cell.value) ? "left" : "right", // Align text left, numbers right
          vertical: "middle",
          wrapText: true, // Ensure text wraps inside the cell
        };
      });
    });

    // Adjust column width based on content
    columns.forEach((col, colIndex) => {
      let maxLength = 5;
      // Check header length
      maxLength = Math.max(
        maxLength,
        col.header.length > 50 ? 50 : col.header.length
      );

      // Check content length in each row
      rowData.forEach((item) => {
        const cellValue = item[col.key] ? String(item[col.key]) : "-";
        maxLength = Math.max(
          maxLength,
          cellValue.length > 50 ? 50 : cellValue.length
        );
      });

      // Set column width based on maximum content length
      const adjustedWidth = Math.max(maxLength + 2, col.width); // Adding some padding
      worksheet.getColumn(colIndex + 1).width = adjustedWidth;
    });

    // Add disclaimer at the bottom
    const lastRowNumber = worksheet.lastRow.number + 2;
    worksheet.mergeCells(lastRowNumber, 1, lastRowNumber, columns.length);
    const disclaimerCell = worksheet.getCell(`A${lastRowNumber}`);
    disclaimerCell.value = `Disclaimer: Capitaline Database has taken due care and caution in compilation of data. However, Capitaline Database makes no warranty that the service will meet all your requirements, the service will be uninterrupted, timely, complete, error-free, or the results that may be obtained from the use of the service will be accurate. Use of data from Capitaline is permitted only to the licensee and its employees' internal usage. The Licensee shall not use Capitaline or data from Capitaline or permit any third party to do so in order to provide data processing, advisory, or research services to third parties by way of trade or otherwise. The Licensee shall also not make the data available on a network that extends beyond the Licensee's premises. In the event of unauthorized use of Capitaline or data from Capitaline by the Licensee, Capital Market Publishers India Pvt. Ltd. will terminate the subscription immediately.`;
    disclaimerCell.font = { italic: true, size: 12 };
    disclaimerCell.alignment = {
      horizontal: "left",
      vertical: "top",
      wrapText: true,
    };
    disclaimerCell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
    worksheet.getRow(lastRowNumber).height = 110;

    // Generate Excel file and download
    const buffer = await workbook.xlsx.writeBuffer();
    const fileSizeInBytes = buffer.byteLength;
    const fileSizeInKB = (fileSizeInBytes / 1024).toFixed(2);
    const fileSizeInMB = (fileSizeInBytes / (1024 * 1024)).toFixed(2);
    Store.dispatch(setExportDetails({ export: 1, size: fileSizeInKB }));
    Store.dispatch(toggleExported());
    const fileName = `${PageName}.xlsx`;
    saveAs(new Blob([buffer]), fileName);
    setTimeout(() => {
      Store.dispatch(setExportDetails({ export: 0, size: 0 }));
    }, 2000);
  } catch (error) {
    console.error("Error exporting Excel:", error);
  }
};

//.... Excel function for monthly-analysis-returns  start here..........

export const exportToExcelMonthlyAnalysis = async (
  LeftHeadMenu,
  PageName,
  CompanyName,
  rsIn,
  currency,
  rowData,
  Consolidated,
  columnDefs,
  tabName,
  pinnedBottomRow
) => {

  try {
    let ConsolidatedValue =
      Consolidated === "true"
        ? "Consolidate"
        : Consolidated === "false"
          ? "Standalone"
          : "";

    const currentDate = new Date().toLocaleString();
    const pageHeader = `${LeftHeadMenu} >> ${PageName} ${ConsolidatedValue ? `(${ConsolidatedValue}) >>` : ""
      }${CompanyName} ${rsIn && currency ? `(Curr. ${rsIn} In ${currency})` : ""
      } ${tabName || ""} - Exported on ${currentDate}`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(tabName || PageName);

    const columns = columnDefs.map((col) => {
      const maxContentLength = Math.max(
        col.headerName.length,
        ...rowData.map((row) => (row[col.field] || "").toString().length)
      );
      return {
        header: col.headerName,
        key: col.field,
        width: Math.max(10, maxContentLength + 2),
      };
    });

    worksheet.columns = columns;


    worksheet.mergeCells(1, 1, 1, columns.length);
    const headerCell = worksheet.getCell("A1");
    headerCell.value = pageHeader;
    headerCell.font = { bold: true, size: 14 };
    headerCell.alignment = { horizontal: "left", vertical: "middle" };

    const headerRow = worksheet.getRow(3);
    headerRow.values = columns.map((col) => col.header);
    headerRow.font = { bold: true };
    headerRow.alignment = { horizontal: "center" };
    headerRow.eachCell((cell) => {
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
      cell.alignment = {
        horizontal: "center",
        vertical: "middle",
        wrapText: true,
      };
    });

    rowData.forEach((item) => {
      const row = columns.map((col) => {
        const colDef = columnDefs.find((def) => def.field === col.key);
        if (colDef && colDef.valueFormatter) {
          return colDef.valueFormatter({
            value: item[col.key],
            data: item,
            colDef,
          });
        }
        return item[col.key] || "-";
      });

      const newRow = worksheet.addRow(row);
      const isBreakupData = item.innerBreakupData === true;
      newRow.eachCell((cell, colIndex) => {
        let year = item.Year;

        let bgColor = "FFFFFF";
        const field = columns[colIndex - 1]?.key;
        const cellValue = item[field];
        let num =
          typeof cellValue === "string"
            ? parseFloat(cellValue.replace("%", ""))
            : parseFloat(cellValue);

        if (
          !isNaN(num) &&
          field !== "Year" &&
          year !== "Maximum" &&
          year !== "Minimum" &&
          year !== "Average" &&
          year !== "Positive Count %" &&
          year !== "Negative Count %"
        ) {
          if (num > 4) {
            bgColor = "90EE90";
          } else if (num >= 2 && num <= 4) {
            bgColor = "BAD9A0";
          } else if (num >= -2 && num < 0) {
            bgColor = "EDB8B8";
          } else if (num < -2) {
            bgColor = "D97878";
          }
        }

        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: bgColor },
        };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };

        if (item.BreakupType === "Y") {
          cell.font = { bold: true };
        }
        if (
          year == "Negative Count %" ||
          year == "Positive Count %" ||
          year == "Average" ||
          year == "Maximum" ||
          year == "Minimum" ||
          year == ""
        ) {
          cell.font = { bold: true };
        }

        if (isBreakupData && colIndex === 2) {
          cell.value = "          " + cell.value;
        }

        if (!cell.value) {
          cell.value = "-";
        }
      });
    });

    worksheet.eachRow((row, rowIndex) => {
      if (rowIndex <= 3) return;
      row.eachCell((cell) => {
        cell.alignment = {
          horizontal: isNaN(cell.value) ? "left" : "right",
          vertical: "middle",
          wrapText: true,
        };
      });
    });

    columns.forEach((col, colIndex) => {
      let maxLength = 5;
      maxLength = Math.max(
        maxLength,
        col.header.length > 50 ? 50 : col.header.length
      );
      rowData.forEach((item) => {
        const cellValue = item[col.key] ? String(item[col.key]) : "-";
        maxLength = Math.max(
          maxLength,
          cellValue.length > 50 ? 50 : cellValue.length
        );
      });
      worksheet.getColumn(colIndex + 1).width = Math.max(
        maxLength + 2,
        col.width
      );
    });


    const lastRowNumber = worksheet.lastRow.number + 1;
    worksheet.mergeCells(lastRowNumber, 1, lastRowNumber, columns.length);
    const disclaimerCell = worksheet.getCell(`A${lastRowNumber}`);
    //disclaimerCell.value = `Disclaimer: Capitaline Database has taken due care and caution in compilation of data. However, Capitaline Database makes no warranty that the service will meet all your requirements...`;
    disclaimerCell.value = ` Note: ${pinnedBottomRow[0].disclaimer}`;
    disclaimerCell.font = { italic: true, size: 12 };
    disclaimerCell.alignment = {
      horizontal: "left",
      vertical: "top",
      wrapText: true,
    };
    disclaimerCell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
    worksheet.getRow(lastRowNumber).height = 80;



    const indicatorRowNumber = worksheet.lastRow.number + 2;

    const indicatorLabels = ["Change%",
      ">4%",
      "2-4%",
      "0-2%",
      "0-(-2)%",
      "<-2%",];
    const indicatorColors = ["FFFFFF",
      "90EE90",
      "BAD9A0",
      "FFFFFF",
      "EDB8B8",
      "D97878",];

    indicatorLabels.forEach((label, index) => {
      const cell = worksheet.getCell(indicatorRowNumber, index + 1);
      cell.value = label;
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: indicatorColors[index] },
      };
      cell.font = {
        bold: true,
        color: { argb: "000000" },
      };
      cell.alignment = {
        horizontal: "center",
        vertical: "middle",
      };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });

    // Optional: Add a title label before buttons
    const titleCell = worksheet.getCell(indicatorRowNumber, 7);
    // titleCell.value = "<-2";
    titleCell.font = { bold: true, italic: true };
    titleCell.alignment = { horizontal: "left", vertical: "middle" };
    worksheet.mergeCells(indicatorRowNumber, 7, indicatorRowNumber, 8);

    const secondRowNumber = lastRowNumber + 4;
    worksheet.mergeCells(secondRowNumber, 1, secondRowNumber, columns.length);
    const secondDisclaimerCell = worksheet.getCell(`A${secondRowNumber}`);
    secondDisclaimerCell.value = `Disclaimer: Capitaline Database has taken due care and caution in compilation of data. However, Capitaline Database makes no warranty that the service will meet all your requirements, the service will always be error-free, or the service will be uninterrupted timely, complete, error-free, or the results that may be obtained from the use of the service will be accurate.Use of data from Capitaline is permitted only to the licensee and its employees internal usage. The Licensee shall not use Capitaline or data from Capitaline or permit any third party to do so in order to provide data processing, advisory, or research services to third parties by way of trade or otherwise. The Licensee shall also not make the data available on a network that extends beyond the Licensee's premises. In the event of unauthorized use of Capitaline or data from Capitaline by the Licensee, Capital Market Publishers India Pvt. Ltd. will terminate the subscription immediately.`;
    secondDisclaimerCell.font = { italic: true, size: 12 };
    secondDisclaimerCell.alignment = {
      horizontal: "left",
      vertical: "top",
      wrapText: true,
    };
    secondDisclaimerCell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
    worksheet.getRow(secondRowNumber).height = 110;

    const buffer = await workbook.xlsx.writeBuffer();
    const fileSizeInKB = (buffer.byteLength / 1024).toFixed(2);
    Store.dispatch(setExportDetails({ export: 1, size: fileSizeInKB }));
    Store.dispatch(toggleExported());

    saveAs(new Blob([buffer]), `${PageName}.xlsx`);
    setTimeout(() => {
      Store.dispatch(setExportDetails({ export: 0, size: 0 }));
    }, 2000);
  } catch (error) {
    console.error("Error exporting Excel:", error);
  }
};

//....Excel function for monthly-analysis-returns  end here..........

// export const exportToExcelWithDoubleHeader = async (
//     Section,
//     LeftHeadMenu,
//     PageName,
//     CompanyName,
//     rsIn,
//     currency,
//     rowData,
//     Consolidated,
//     columnDefs,
//     tabName
// ) => {
//     try {
//         // Directly setting page header to "My Page"

//         let ConsolidatedValue;
//         if (Consolidated === "true") {
//             ConsolidatedValue = "Consolidate";
//         } else if (Consolidated === "false") {
//             ConsolidatedValue = "Standalone";
//         } else {
//             ConsolidatedValue = "";
//         }

//         const pageHeader = `${Section} >> ${LeftHeadMenu} >> ${PageName} ${ConsolidatedValue === "" ? "" : `(${ConsolidatedValue})  >>`
//             }${CompanyName} (Curr. ${rsIn} In ${currency}) ${tabName === "" || undefined || null ? "" : `(${tabName})`
//             }`;
//         // Create a new workbook
//         const workbook = new ExcelJS.Workbook();
//         const worksheet = workbook.addWorksheet(tabName || PageName);

//         // Clear any previous content in the worksheet
//         worksheet.eachRow((row, rowNumber) => {
//             row.eachCell((cell, colNumber) => {
//                 cell.value = null;
//             });
//         });

//         // Add the page header to row 1

//         // Adding primary and secondary headers
//         const primaryHeaders = [{ header: " ", mergeAcross: 1 }];
//         const secondaryHeaders = [{ header: "Sr.No", key: "srNo", width: 8 }];

//         columnDefs.forEach((col) => {
//             if (col.children && col.children.length > 0) {
//                 primaryHeaders.push({ header: col.headerName, mergeAcross: col.children.length });
//                 col.children.forEach((childCol) => {
//                     secondaryHeaders.push({
//                         header: childCol.headerName,
//                         key: childCol.field,
//                         width: Math.max(10, childCol.width / 7 || 15),
//                     });
//                 });
//             } else {
//                 primaryHeaders.push({ header: col.headerName, mergeAcross: 1 });
//                 secondaryHeaders.push({
//                     header: col.headerName,
//                     key: col.field,
//                     width: Math.max(10, col.width / 7 || 15),
//                 });
//             }
//         });

//         // Add primary headers with borders
//         let currentColumnIndex = 1;
//         primaryHeaders.forEach((header) => {
//             const mergeEnd = currentColumnIndex + (header.mergeAcross || 1) - 1;
//             worksheet.mergeCells(2, currentColumnIndex, 2, mergeEnd);
//             const cell = worksheet.getCell(2, currentColumnIndex);
//             cell.value = header.header;
//             cell.font = { bold: true };
//             cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };

//             // Add borders to primary header cells
//             const borderStyle = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
//             cell.border = borderStyle;

//             currentColumnIndex = mergeEnd + 1;
//         });

//         // Add secondary headers (child headers) with borders
//         secondaryHeaders.forEach((col, index) => {
//             const cell = worksheet.getCell(3, index + 1);
//             cell.value = col.header;
//             cell.font = { bold: true };
//             cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };

//             // Add borders to secondary header cells
//             const borderStyle = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
//             cell.border = borderStyle;
//         });

//         // Set column widths and add data
//         worksheet.columns = secondaryHeaders;

//         worksheet.mergeCells(1, 1, 1, PageName === 'MFI Category Wise Turnover' || 'MF Investments' || 'MF Investments-Derivatives' || 'FII Investments' ? columnDefs.length + columnDefs.length + 3 : columnDefs.length + 1);  // Adjust merge for the columnDefs length
//         const headerCell = worksheet.getCell("A1");
//         headerCell.value = pageHeader;  // Page header
//         headerCell.font = { bold: true, size: 14 };
//         headerCell.alignment = { horizontal: "left", vertical: "middle", wrapText: true };

//         // Add row data

//         worksheet.eachRow((row, rowIndex) => {
//             if (rowIndex <= 2) return; // Skip header rows

//             row.eachCell((cell, colIndex) => {
//                 // Detect if cell value is a number
//                 if (!isNaN(cell.value) && cell.value !== "" && cell.value !== null) {
//                     cell.alignment = {
//                         horizontal: "right",
//                         vertical: "middle",
//                         wrapText: true,
//                     };
//                 } else {
//                     cell.alignment = {
//                         horizontal: "left",
//                         vertical: "middle",
//                         wrapText: true,
//                     };
//                 }
//             });
//         });

//         rowData.forEach((row, rowIndex) => {
//             const rowValues = [rowIndex + 1];  // Add Sr.No column
//             secondaryHeaders.slice(1).forEach((col) => {
//                 rowValues.push(row[col.key] !== undefined ? row[col.key] : "-");
//             });
//             const newRow = worksheet.addRow(rowValues);
//             const isBreakupData = row.innerBreakupData === true;

//             newRow.eachCell((cell, colIndex) => {
//                 cell.fill = {
//                     type: "pattern",
//                     pattern: "solid",
//                     fgColor: { argb: "FFFFFF" },
//                 };
//                 cell.border = {
//                     top: { style: "thin" },
//                     left: { style: "thin" },
//                     bottom: { style: "thin" },
//                     right: { style: "thin" },
//                 };
//                 if (row.BreakupType === 'Y') {
//                     cell.font = { bold: true };
//                 }
//                 if (isBreakupData && colIndex === 2) { // Column 2 should be the DISPLAYNAME column
//                     cell.value = "          " + cell.value;  // Prepend spaces to create a "margin"
//                 }
//                 if (!cell.value) {
//                     cell.value = cell.value || "-"; // Ensure every cell has a default value
//                 }

//             });
//         });

//         // Add disclaimer
//         const lastRowNumber = worksheet.lastRow.number + 2;
//         worksheet.mergeCells(lastRowNumber, 1, lastRowNumber, secondaryHeaders.length);
//         worksheet.getCell(`A${lastRowNumber}`).value = "Disclaimer: Capitaline Database has taken due care and caution in compilation of data. However, Capitaline Database makes no warranty that the service will meet all your requirements, the service will be uninterrupted, timely, complete, error-free, or the results that may be obtained from the use of the service will be accurate. Use of data from Capitaline is permitted only to the licensee and its employees' internal usage. The Licensee shall not use Capitaline or data from Capitaline or permit any third party to do so in order to provide data processing, advisory, or research services to third parties by way of trade or otherwise. The Licensee shall also not make the data available on a network that extends beyond the Licensee's premises. In the event of unauthorized use of Capitaline or data from Capitaline by the Licensee, Capital Market Publishers India Pvt. Ltd. will terminate the subscription immediately.";
//         worksheet.getCell(`A${lastRowNumber}`).font = { italic: true, size: 12 };
//         worksheet.getCell(`A${lastRowNumber}`).alignment = { horizontal: "left", vertical: "top", wrapText: true };
//         worksheet.getRow(lastRowNumber).height = 110;
//         // Save the workbook
//         const buffer = await workbook.xlsx.writeBuffer();
//         saveAs(new Blob([buffer]), `${PageName}.xlsx`);
//     } catch (error) {
//         console.error("Error exporting to Excel:", error);
//     }
// };

// export const exportToExcelSingleBinding = async (Section, LeftHeadMenu, PageName, CompanyName, rsIn, currency, rowData, Consolidated, columnDefs, tabName) => {
//     try {
//         let ConsolidatedValue;
//         if (Consolidated === 'true') {
//             ConsolidatedValue = 'Consolidate';
//         } else if (Consolidated === 'false') {
//             ConsolidatedValue = 'Standalone';
//         } else {
//             ConsolidatedValue = '';
//         }

//         const pageHeader = `${Section ? `${Section} >>` : ''}${LeftHeadMenu} >> ${PageName} ${ConsolidatedValue === '' ? '' : `(${ConsolidatedValue})`} >> ${CompanyName} (Curr. ${rsIn} In ${currency})`;

//         // Create a new workbook
//         const workbook = new ExcelJS.Workbook();
//         const worksheet = workbook.addWorksheet(tabName ? tabName : PageName);

//         // Define columns based on columnDefs
//         // const hasSrNo = columnDefs.some(col => col.headerName === 'Sr. No.' || col.field === 'srno');

//         // Define columns, add Sr. No. column only if not already present
//         const columns = [
//             { header: 'Sr. No.', key: 'srno', width: 10 }, // Add Sr. No. column
//             ...columnDefs.map((col) => ({
//                 header: col.headerName,
//                 key: col.field,
//                 width: col.width / 12, // Adjust width dynamically for better fit
//             })),
//         ];
//         worksheet.columns = columns;

//         // Merge header row
//         worksheet.mergeCells(1, 1, 1, columns.length);
//         const headerCell = worksheet.getCell("A1");
//         headerCell.value = pageHeader;
//         headerCell.font = { bold: true, size: 14 };
//         headerCell.alignment = { horizontal: "left", vertical: "middle" };

//         // Adding column headers
//         const headerRow = worksheet.getRow(2);
//         headerRow.values = columns.map((col) => col.header);
//         headerRow.font = { bold: true };
//         headerRow.alignment = { horizontal: "center" };
//         headerRow.eachCell((cell) => {
//             cell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
//             cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
//         });

//         // Adding data rows
//         // rowData.forEach((item, rowIndex) => {
//         //     // const row = [
//         //     //     rowIndex + 1, // Serial number column
//         //     //     ...columns.slice(1).map((col) => {
//         //     //         const colDef = columnDefs.find((def) => def.field === col.key);
//         //     //         if (colDef && colDef.valueFormatter) {
//         //     //             return colDef.valueFormatter({ value: item[col.key] });
//         //     //         }
//         //     //         return item[col.key] || "" // Default value if no formatter
//         //     //     }),
//         //     // ];

//         //     // const row = [
//         //     //     rowIndex + 1, // Add serial number for the first column
//         //     //     ...columns.slice(1).map((col) => {
//         //     //         const colDef = columnDefs.find((def) => def.field === col.key);
//         //     //         if (colDef && colDef.valueFormatter) {
//         //     //             // Use valueFormatter if defined in columnDefs
//         //     //             return colDef.valueFormatter({ value: item[col.key], data: item, colDef });
//         //     //         }
//         //     //         return item[col.key] || "-"; // Default to "-" if no value
//         //     //     }),
//         //     // ];

//         //     // worksheet.addRow(row);
//         //     const newRow = worksheet.addRow(row);

//         //     const isBreakupData = item.innerBreakupData === true;

//         //     newRow.eachCell((cell, colIndex) => {
//         //         cell.fill = {
//         //             type: "pattern",
//         //             pattern: "solid",
//         //             fgColor: { argb: "FFFFFF" },
//         //         };
//         //         cell.border = {
//         //             top: { style: "thin" },
//         //             left: { style: "thin" },
//         //             bottom: { style: "thin" },
//         //             right: { style: "thin" },
//         //         };

//         //         if (item.BreakupType === 'Y') {
//         //             cell.font = { bold: true };
//         //         }
//         //         if (isBreakupData && colIndex === 2) { // Column 2 should be the DISPLAYNAME column
//         //             cell.value = "          " + cell.value; // Prepend spaces to create a "margin"
//         //         }

//         //         const totalColumns = columns.length;
//         //         for (let colIndex = 1; colIndex <= totalColumns; colIndex++) {
//         //             const cell = newRow.getCell(colIndex);
//         //             cell.border = {
//         //                 top: { style: "thin" },
//         //                 left: { style: "thin" },
//         //                 bottom: { style: "thin" },
//         //                 right: { style: "thin" },
//         //             };
//         //             if (!cell.value) {
//         //                 cell.value = "-"; // Ensure every cell has a default value
//         //             }
//         //         }
//         //     });
//         // });
//         rowData.forEach((item, rowIndex) => {
//             const row = [
//                 rowIndex + 1, // Serial number column
//                 ...columns.slice(1).map((col) => {
//                     const colDef = columnDefs.find((def) => def.field === col.key);
//                     if (colDef && colDef.valueFormatter) {
//                         return colDef.valueFormatter({ value: item[col.key] });
//                     }
//                     return item[col.key] || "-"; // Default value if no formatter
//                 }),
//             ];
//             // worksheet.addRow(row);
//             const newRow = worksheet.addRow(row);

//             const isBreakupData = item.innerBreakupData === true;

//             newRow.eachCell((cell, colIndex) => {
//                 cell.fill = {
//                     type: "pattern",
//                     pattern: "solid",
//                     fgColor: { argb: "FFFFFF" },
//                 };
//                 cell.border = {
//                     top: { style: "thin" },
//                     left: { style: "thin" },
//                     bottom: { style: "thin" },
//                     right: { style: "thin" },
//                 };
//                 if (item.BreakupType === 'Y') {
//                     cell.font = { bold: true };
//                 }
//                 if (isBreakupData && colIndex === 2) { // Column 2 should be the DISPLAYNAME column
//                     cell.value = "          " + cell.value;  // Prepend spaces to create a "margin"
//                 }

//             });
//         });

//         worksheet.eachRow((row, rowIndex) => {
//             if (rowIndex <= 2) return; // Skip header rows
//             row.eachCell((cell) => {
//                 cell.alignment = { horizontal: "left", vertical: 'middle', wrapText: true };
//             });
//         });

//         // Adjust column width based on content
//         columns.forEach((col, colIndex) => {
//             let maxLength = 5;
//             // Check header length
//             maxLength = Math.max(maxLength, col.header.length > 50 ? 50 : col.header.length);

//             // Check content length in each row
//             rowData.forEach((item) => {
//                 const cellValue = item[col.key] ? String(item[col.key]) : "-";
//                 maxLength = Math.max(maxLength, cellValue.length > 50 ? 50 : cellValue.length);
//             });

//             // Set column width based on maximum content length
//             const adjustedWidth = Math.max(maxLength + 2, col.width); // Adding some padding
//             worksheet.getColumn(colIndex + 1).width = adjustedWidth;
//         });

//         // Add disclaimer at the bottom
//         const lastRowNumber = worksheet.lastRow.number + 2;
//         worksheet.mergeCells(lastRowNumber, 1, lastRowNumber, columns.length);
//         const disclaimerCell = worksheet.getCell(`A${lastRowNumber}`);
//         disclaimerCell.value = `Disclaimer: Capitaline Database has taken due care and caution in compilation of data. However, Capitaline Database makes no warranty that the service will meet all your requirements, the service will be uninterrupted, timely, complete, error-free, or the results that may be obtained from the use of the service will be accurate. Use of data from Capitaline is permitted only to the licensee and its employees' internal usage. The Licensee shall not use Capitaline or data from Capitaline or permit any third party to do so in order to provide data processing, advisory, or research services to third parties by way of trade or otherwise. The Licensee shall also not make the data available on a network that extends beyond the Licensee's premises. In the event of unauthorized use of Capitaline or data from Capitaline by the Licensee, Capital Market Publishers India Pvt. Ltd. will terminate the subscription immediately.`;
//         disclaimerCell.font = { italic: true, size: 12 };
//         disclaimerCell.alignment = { horizontal: "left", vertical: "top", wrapText: true };
//         disclaimerCell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
//         worksheet.getRow(lastRowNumber).height = 110;

//         // Generate Excel file and download
//         const buffer = await workbook.xlsx.writeBuffer();
//         const fileName = `${PageName}.xlsx`;
//         saveAs(new Blob([buffer]), fileName);

//     } catch (error) {
//         console.error("Error exporting Excel:", error);
//     }
// };

// export const exportToExcelSingleBinding = async (LeftHeadMenu, PageName, CompanyName, rsIn, currency, rowData, Consolidated, columnDefs, tabName) => {
//     try {
//         let ConsolidatedValue;
//         if (Consolidated === 'true') {
//             ConsolidatedValue = 'Consolidate';
//         } else if (Consolidated === 'false') {
//             ConsolidatedValue = 'Standalone';
//         } else {
//             ConsolidatedValue = '';
//         }

//         const pageHeader = `${LeftHeadMenu} > ${PageName} ${ConsolidatedValue === '' ? '' : `(${ConsolidatedValue})`} > ${CompanyName} (Curr. ${rsIn} In ${currency})`;

//         // Create a new workbook
//         const workbook = new ExcelJS.Workbook();
//         const worksheet = workbook.addWorksheet(tabName ? tabName : PageName);

//         // Define columns based on columnDefs
//         const columns = [
//             { header: 'Sr. No.', key: 'srno', width: 10 }, // Add Sr. No. column
//             ...columnDefs.map((col) => ({
//                 header: col.headerName,
//                 key: col.field,
//                 width: col.width / 12, // Adjust width dynamically for better fit
//             })),
//         ];

//         worksheet.columns = columns;

//         // Merge header row
//         worksheet.mergeCells(1, 1, 1, columns.length);
//         const headerCell = worksheet.getCell("A1");
//         headerCell.value = pageHeader;
//         headerCell.font = { bold: true, size: 14 };
//         headerCell.alignment = { horizontal: "left", vertical: "middle" };

//         // Adding column headers
//         const headerRow = worksheet.getRow(2);
//         headerRow.values = columns.map((col) => col.header);
//         headerRow.font = { bold: true };
//         headerRow.alignment = { horizontal: "center" };
//         headerRow.eachCell((cell) => {
//             cell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
//             cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
//         });

//         // Adding data rows
//         rowData.forEach((item, rowIndex) => {
//             const row = [
//                 rowIndex + 1, // Serial number column
//                 ...columns.slice(1).map((col) => {
//                     const colDef = columnDefs.find((def) => def.field === col.key);
//                     if (colDef && colDef.valueFormatter) {
//                         return colDef.valueFormatter({ value: item[col.key] });
//                     }
//                     return item[col.key] || "-"; // Default value if no formatter
//                 }),
//             ];
//             // worksheet.addRow(row);
//             const newRow = worksheet.addRow(row);

//             const isBreakupData = item.innerBreakupData === true;

//             newRow.eachCell((cell, colIndex) => {
//                 cell.fill = {
//                     type: "pattern",
//                     pattern: "solid",
//                     fgColor: { argb: "FFFFFF" },
//                 };
//                 cell.border = {
//                     top: { style: "thin" },
//                     left: { style: "thin" },
//                     bottom: { style: "thin" },
//                     right: { style: "thin" },
//                 };
//                 if (item.BreakupType === 'Y') {
//                     cell.font = { bold: true };
//                 }
//                 if (isBreakupData && colIndex === 2) { // Column 2 should be the DISPLAYNAME column
//                     cell.value = "          " + cell.value;  // Prepend spaces to create a "margin"
//                 }

//             });
//         });

//         worksheet.eachRow((row, rowIndex) => {
//             if (rowIndex <= 2) return; // Skip header rows
//             row.eachCell((cell) => {
//                 cell.alignment = { horizontal: "left", vertical: 'middle', wrapText: true };
//             });
//         });

//         // Adjust column width based on content
//         columns.forEach((col, colIndex) => {
//             let maxLength = 0;
//             // Check header length
//             maxLength = Math.max(maxLength, col.header.length > 50 ? 50 : col.header.length);

//             // Check content length in each row
//             rowData.forEach((item) => {
//                 const cellValue = item[col.key] ? String(item[col.key]) : "-";
//                 maxLength = Math.max(maxLength, cellValue.length > 50 ? 50 : cellValue.length);
//             });

//             // Set column width based on maximum content length
//             const adjustedWidth = Math.max(maxLength + 2, col.width); // Adding some padding
//             worksheet.getColumn(colIndex + 1).width = adjustedWidth;
//         });

//         // Add disclaimer at the bottom
//         const lastRowNumber = worksheet.lastRow.number + 2;
//         worksheet.mergeCells(lastRowNumber, 1, lastRowNumber, columns.length);
//         const disclaimerCell = worksheet.getCell(`A${lastRowNumber}`);
//         disclaimerCell.value = `Disclaimer: Capitaline Database has taken due care and caution in compilation of data. However, Capitaline Database makes no warranty that the service will meet all your requirements, the service will be uninterrupted, timely, complete, error-free, or the results that may be obtained from the use of the service will be accurate. Use of data from Capitaline is permitted only to the licensee and its employees' internal usage. The Licensee shall not use Capitaline or data from Capitaline or permit any third party to do so in order to provide data processing, advisory, or research services to third parties by way of trade or otherwise. The Licensee shall also not make the data available on a network that extends beyond the Licensee's premises. In the event of unauthorized use of Capitaline or data from Capitaline by the Licensee, Capital Market Publishers India Pvt. Ltd. will terminate the subscription immediately.`;
//         disclaimerCell.font = { italic: true, size: 12 };
//         disclaimerCell.alignment = { horizontal: "left", vertical: "top", wrapText: true };
//         disclaimerCell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
//         worksheet.getRow(lastRowNumber).height = 110;

//         // Generate Excel file and download
//         const buffer = await workbook.xlsx.writeBuffer();
//         const fileName = `${PageName}.xlsx`;
//         saveAs(new Blob([buffer]), fileName);

//     } catch (error) {
//         console.error("Error exporting Excel:", error);
//     }
// };

// export const exportToExcelWithDoubleHeader = async (
//   Section,
//   LeftHeadMenu,
//   PageName,
//   CompanyName,
//   rsIn,
//   currency,
//   rowData,
//   Consolidated,
//   columnDefs,
//   tabName
// ) => {
//   try {
//     let ConsolidatedValue;
//     if (Consolidated === "true") {
//       ConsolidatedValue = "Consolidate";
//     } else if (Consolidated === "false") {
//       ConsolidatedValue = "Standalone";
//     } else {
//       ConsolidatedValue = "";
//     }

//     const pageHeader = `${Section} >> ${LeftHeadMenu} >> ${PageName} ${ConsolidatedValue === "" ? "" : `(${ConsolidatedValue})  >>`
//       }${CompanyName} (Curr. ${rsIn} In ${currency}) ${tabName === "" || undefined || null ? "" : `(${tabName})`
//       }`;

//     // Create a new workbook
//     const workbook = new ExcelJS.Workbook();
//     const worksheet = workbook.addWorksheet(tabName || PageName);

//     // Clear any previous content in the worksheet
//     worksheet.eachRow((row, rowNumber) => {
//       row.eachCell((cell, colNumber) => {
//         cell.value = null;
//       });
//     });

//     // Add the page header to row 1

//     // Adding primary and secondary headers
//     const primaryHeaders = [];
//     const secondaryHeaders = [];

//     columnDefs.forEach((col) => {
//       if (col.children && col.children.length > 0) {
//         primaryHeaders.push({
//           header: col.headerName,
//           mergeAcross: col.children.length,
//         });
//         col.children.forEach((childCol) => {
//           secondaryHeaders.push({
//             header: childCol.headerName,
//             key: childCol.field,
//             width: Math.max(10, childCol.width / 7 || 15),
//           });
//         });
//       } else {
//         primaryHeaders.push({ header: col.headerName, mergeAcross: 1 });
//         secondaryHeaders.push({
//           header: col.headerName,
//           key: col.field,
//           width: Math.max(10, col.width / 7 || 15),
//         });
//       }
//     });

//     // Add primary headers with borders
//     let currentColumnIndex = 1;
//     primaryHeaders.forEach((header) => {
//       const mergeEnd = currentColumnIndex + (header.mergeAcross || 1) - 1;
//       worksheet.mergeCells(2, currentColumnIndex, 2, mergeEnd);
//       const cell = worksheet.getCell(2, currentColumnIndex);
//       cell.value = header.header;
//       cell.font = { bold: true };
//       cell.alignment = {
//         horizontal: "center",
//         vertical: "middle",
//         wrapText: true,
//       };

//       // Add borders to primary header cells
//       const borderStyle = {
//         top: { style: "thin" },
//         left: { style: "thin" },
//         bottom: { style: "thin" },
//         right: { style: "thin" },
//       };
//       cell.border = borderStyle;

//       currentColumnIndex = mergeEnd + 1;
//     });

//     // Add secondary headers (child headers) with borders
//     secondaryHeaders.forEach((col, index) => {
//       const cell = worksheet.getCell(3, index + 1);
//       cell.value = col.header;
//       cell.font = { bold: true };
//       cell.alignment = {
//         horizontal: "center",
//         vertical: "middle",
//         wrapText: true,
//       };

//       // Add borders to secondary header cells
//       const borderStyle = {
//         top: { style: "thin" },
//         left: { style: "thin" },
//         bottom: { style: "thin" },
//         right: { style: "thin" },
//       };
//       cell.border = borderStyle;
//     });

//     // Set column widths and add data
//     worksheet.columns = secondaryHeaders;

//     worksheet.mergeCells(
//       1,
//       1,
//       1,
//       PageName === "MFI Category Wise Turnover" ||
//         "MF Investments" ||
//         "MF Investments-Derivatives" ||
//         "FII Investments"
//         ? columnDefs.length + columnDefs.length + 3
//         : columnDefs.length + 1
//     );
//     const headerCell = worksheet.getCell("A1");
//     headerCell.value = pageHeader; // Page header
//     headerCell.font = { bold: true, size: 14 };
//     headerCell.alignment = {
//       horizontal: "left",
//       vertical: "middle",
//       wrapText: true,
//     };

//     // Add row data

//     worksheet.eachRow((row, rowIndex) => {
//       if (rowIndex <= 2) return; // Skip header rows

//       row.eachCell((cell, colIndex) => {
//         // Detect if cell value is a number
//         if (!isNaN(cell.value) && cell.value !== "" && cell.value !== null) {
//           cell.alignment = {
//             horizontal: "right",
//             vertical: "middle",
//             wrapText: true,
//           };
//         } else {
//           cell.alignment = {
//             horizontal: "left",
//             vertical: "middle",
//             wrapText: true,
//           };
//         }
//       });
//     });

//     rowData.forEach((row) => {
//       const rowValues = []; // No Sr.No column now
//       secondaryHeaders.forEach((col) => {
//         rowValues.push(row[col.key] !== undefined ? row[col.key] : "-");
//       });
//       const newRow = worksheet.addRow(rowValues);
//       const isBreakupData = row.innerBreakupData === true;

//       newRow.eachCell((cell, colIndex) => {
//         cell.fill = {
//           type: "pattern",
//           pattern: "solid",
//           fgColor: { argb: "FFFFFF" },
//         };
//         cell.border = {
//           top: { style: "thin" },
//           left: { style: "thin" },
//           bottom: { style: "thin" },
//           right: { style: "thin" },
//         };
//         if (row.BreakupType === "Y") {
//           cell.font = { bold: true };
//         }
//         if (isBreakupData && colIndex === 2) {
//           // Column 2 should be the DISPLAYNAME column
//           cell.value = "          " + cell.value; // Prepend spaces to create a "margin"
//         }
//         if (!cell.value) {
//           cell.value = cell.value || "-"; // Ensure every cell has a default value
//         }
//       });
//     });

//     // Add disclaimer
//     const lastRowNumber = worksheet.lastRow.number + 2;
//     worksheet.mergeCells(
//       lastRowNumber,
//       1,
//       lastRowNumber,
//       secondaryHeaders.length
//     );
//     worksheet.getCell(`A${lastRowNumber}`).value =
//       "Disclaimer: Capitaline Database has taken due care and caution in compilation of data. However, Capitaline Database makes no warranty that the service will meet all your requirements, the service will be uninterrupted, timely, complete, error-free, or the results that may be obtained from the use of the service will be accurate. Use of data from Capitaline is permitted only to the licensee and its employees' internal usage. The Licensee shall not use Capitaline or data from Capitaline or permit any third party to do so in order to provide data processing, advisory, or research services to third parties by way of trade or otherwise. The Licensee shall also not make the data available on a network that extends beyond the Licensee's premises. In the event of unauthorized use of Capitaline or data from Capitaline by the Licensee, Capital Market Publishers India Pvt. Ltd. will terminate the subscription immediately.";
//     worksheet.getCell(`A${lastRowNumber}`).font = { italic: true, size: 12 };
//     worksheet.getCell(`A${lastRowNumber}`).alignment = {
//       horizontal: "left",
//       vertical: "top",
//       wrapText: true,
//     };
//     worksheet.getRow(lastRowNumber).height = 110;

//     // Save the workbook
//     const buffer = await workbook.xlsx.writeBuffer();
//     const fileSizeInBytes = buffer.byteLength;
//     const fileSizeInKB = (fileSizeInBytes / 1024).toFixed(2);
//     const fileSizeInMB = (fileSizeInBytes / (1024 * 1024)).toFixed(2);
//     Store.dispatch(setExportDetails({ export: 1, size: fileSizeInKB }));
//     Store.dispatch(toggleExported());
//     saveAs(new Blob([buffer]), `${PageName}.xlsx`);
//     setTimeout(() => {
//       Store.dispatch(setExportDetails({ export: 0, size: 0 }));
//     }, 2000);
//   } catch (error) {
//     console.error("Error exporting to Excel:", error);
//   }
// };


export const exportToExcelWithDoubleHeader = async (
  Section,
  LeftHeadMenu,
  PageName,
  CompanyName,
  rsIn,
  currency,
  rowData,
  Consolidated,
  columnDefs,
  tabName
) => {
  try {
    let ConsolidatedValue;
    if (Consolidated === "true") {
      ConsolidatedValue = "Consolidate";
    } else if (Consolidated === "false") {
      ConsolidatedValue = "Standalone";
    } else {
      ConsolidatedValue = "";
    }

    const pageHeader = `${Section} >> ${LeftHeadMenu} >> ${PageName} ${ConsolidatedValue === "" ? "" : `(${ConsolidatedValue})  >>`
      }${CompanyName} (Curr. ${rsIn} In ${currency}) ${tabName === "" || undefined || null ? "" : `(${tabName})`
      }`;

    // Create a new workbook
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(tabName || PageName);

    // Flatten columnDefs (to get easy access to field and valueFormatter)
    const flattenColumnDefs = (defs) => {
      const flat = [];
      defs.forEach((col) => {
        if (col.children && Array.isArray(col.children)) {
          flat.push(...flattenColumnDefs(col.children));
        } else {
          flat.push(col);
        }
      });
      return flat;
    };
    const columnDefsFlat = flattenColumnDefs(columnDefs);

    // Build headers
    const primaryHeaders = [];
    const secondaryHeaders = [];

    columnDefs.forEach((col) => {
      if (col.children && col.children.length > 0) {
        primaryHeaders.push({
          header: col.headerName,
          mergeAcross: col.children.length,
        });
        col.children.forEach((childCol) => {
          secondaryHeaders.push({
            header: childCol.headerName,
            key: childCol.field,
            width: Math.max(10, childCol.width / 7 || 15),
          });
        });
      } else {
        primaryHeaders.push({ header: " ", mergeAcross: 1 });
        secondaryHeaders.push({
          header: col.headerName,
          key: col.field,
          width: Math.max(10, col.width / 7 || 15),
        });
      }
    });

    // Set headers in worksheet
    let currentColumnIndex = 1;
    primaryHeaders.forEach((header) => {
      const mergeEnd = currentColumnIndex + (header.mergeAcross || 1) - 1;
      worksheet.mergeCells(2, currentColumnIndex, 2, mergeEnd);
      const cell = worksheet.getCell(2, currentColumnIndex);
      cell.value = header.header;
      cell.font = { bold: true };
      cell.alignment = {
        horizontal: "center",
        vertical: "middle",
        wrapText: true,
      };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
      currentColumnIndex = mergeEnd + 1;
    });

    secondaryHeaders.forEach((col, index) => {
      const cell = worksheet.getCell(3, index + 1);
      cell.value = col.header;
      cell.font = { bold: true };
      cell.alignment = {
        horizontal: "center",
        vertical: "middle",
        wrapText: true,
      };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });

    // Set column widths
    worksheet.columns = secondaryHeaders;

    // Merge and style the big page header at the top
    worksheet.mergeCells(
      1,
      1,
      1,
      secondaryHeaders.length
    );
    const headerCell = worksheet.getCell("A1");
    headerCell.value = pageHeader;
    headerCell.font = { bold: true, size: 14 };
    headerCell.alignment = {
      horizontal: "left",
      vertical: "middle",
      wrapText: true,
    };

    // Add data rows
    rowData.forEach((row) => {
      const rowValues = [];
      secondaryHeaders.forEach((col) => {
        const rawValue = row[col.key];
        const matchingColDef = columnDefsFlat.find(def => def.field === col.key);
        let formattedValue;

        if (matchingColDef && typeof matchingColDef.valueFormatter === 'function') {
          // Call the formatter
          formattedValue = matchingColDef.valueFormatter({ value: rawValue, data: row });

          // Check if original value is a number and formattedValue looks like a formatted string
          const isNumber = typeof rawValue === 'number' && !isNaN(rawValue);
          const isFormattedString = typeof formattedValue === 'string';

          if (isNumber && isFormattedString) {
            // For Excel, store as number (rawValue), but set the number format if possible
            formattedValue = rawValue;
          }
        } else {
          formattedValue = rawValue !== undefined && rawValue !== null ? rawValue : "-";
        }

        rowValues.push(formattedValue);
      });

      const newRow = worksheet.addRow(rowValues);

      // Apply number formats and styling per cell
      newRow.eachCell((cell, colIndex) => {
        const colKey = secondaryHeaders[colIndex - 1]?.key;
        const colDef = columnDefsFlat.find(def => def.field === colKey);

        // Reset fill and border styles as before
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFFFF" },
        };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };

        // Bold font for breakup rows
        if (row.BreakupType === "Y") {
          cell.font = { bold: true };
        }
        // Indentation for breakup data on second column
        if (row.innerBreakupData === true && colIndex === 2) {
          cell.value = "          " + cell.value;
        }

        // Set Excel number format if column defines it or default for numbers
        if (colDef) {
          if (colDef.type === "number" || typeof row[colDef.field] === 'number') {
            // If you have custom formats, apply here, else default '#,##0.00'
            cell.numFmt = colDef.excelNumberFormat || '#,##0.00';
          }
        }

        // Ensure default fallback value
        if (cell.value === null || cell.value === undefined) {
          cell.value = "-";
        }
      });
    });

    // Adjust cell alignment after rows added
    worksheet.eachRow((row, rowIndex) => {
      if (rowIndex <= 3) return;
      row.eachCell((cell) => {
        if (!isNaN(cell.value) && cell.value !== "" && cell.value !== null && typeof cell.value !== 'string') {
          cell.alignment = {
            horizontal: "right",
            vertical: "middle",
            wrapText: true,
          };
        } else {
          cell.alignment = {
            horizontal: "left",
            vertical: "middle",
            wrapText: true,
          };
        }
      });
    });

    // Disclaimer
    const lastRowNumber = worksheet.lastRow.number + 2;
    worksheet.mergeCells(
      lastRowNumber,
      1,
      lastRowNumber,
      secondaryHeaders.length
    );
    worksheet.getCell(`A${lastRowNumber}`).value =
      "Disclaimer: Capitaline Database has taken due care and caution in compilation of data. However, Capitaline Database makes no warranty that the service will meet all your requirements, the service will be uninterrupted, timely, complete, error-free, or the results that may be obtained from the use of the service will be accurate. Use of data from Capitaline is permitted only to the licensee and its employees' internal usage. The Licensee shall not use Capitaline or data from Capitaline or permit any third party to do so in order to provide data processing, advisory, or research services to third parties by way of trade or otherwise. The Licensee shall also not make the data available on a network that extends beyond the Licensee's premises. In the event of unauthorized use of Capitaline or data from Capitaline by the Licensee, Capital Market Publishers India Pvt. Ltd. will terminate the subscription immediately.";
    worksheet.getCell(`A${lastRowNumber}`).font = { italic: true, size: 12 };
    worksheet.getCell(`A${lastRowNumber}`).alignment = {
      horizontal: "left",
      vertical: "top",
      wrapText: true,
    };
    worksheet.getRow(lastRowNumber).height = 110;

    // Save Excel file
    const buffer = await workbook.xlsx.writeBuffer();
    const fileSizeInBytes = buffer.byteLength;
    const fileSizeInKB = (fileSizeInBytes / 1024).toFixed(2);
    Store.dispatch(setExportDetails({ export: 1, size: fileSizeInKB }));
    Store.dispatch(toggleExported());
    saveAs(new Blob([buffer]), `${PageName}.xlsx`);
    setTimeout(() => {
      Store.dispatch(setExportDetails({ export: 0, size: 0 }));
    }, 2000);
  } catch (error) {
    console.error("Error exporting to Excel:", error);
  }
};




export const encrypt = (text) => {
  const encrypted = CryptoJS.AES.encrypt(text, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString(); // returns Base64 string
};


export const UserListedValue = () => {
  const UserDetails = useSelector((state) => state.LoginUserDetails.data);

  let parsedDetails = typeof UserDetails === 'string' ? JSON.parse(UserDetails) : UserDetails;
  let Listed_Only = parsedDetails?.[0]?.Listed_Only;
  return Listed_Only
};


export const UserTypeValue = () => {
  const UserDetails = useSelector((state) => state.LoginUserDetails.data);

  let parsedDetails = typeof UserDetails === 'string' ? JSON.parse(UserDetails) : UserDetails;
  let UserType = parsedDetails?.[0]?.UserType == 'X ' ? "X" : "";
  return UserType
};


export const UserProductIDValue = () => {
  const UserDetails = useSelector((state) => state.LoginUserDetails?.data);

  let parsedDetails = typeof UserDetails === 'string' ? JSON.parse(UserDetails) : UserDetails;
  let prodId = parsedDetails?.[0]?.ProductID ??
               parsedDetails?.[0]?.ProductId ??
               parsedDetails?.[0]?.product_id ??
               parsedDetails?.[0]?.productid ??
               parsedDetails?.[0]?.ICAIuser ??
               sessionStorage.getItem('productid') ??
               sessionStorage.getItem('ProductID') ??
               sessionStorage.getItem('productId') ??
               localStorage.getItem('productid') ??
               localStorage.getItem('ProductID') ??
               localStorage.getItem('productId');

  if (!prodId && parsedDetails?.[0]?.Product) {
    const pName = String(parsedDetails[0].Product).toLowerCase();
    if (pName.includes('e-magazine') || pName.includes('emagazine')) {
      return '4';
    }
  }

  return prodId ? String(prodId).trim() : '';
};


// Excel functionality for Market Statistics and Stock-analysis



export const exportDynamicExcel = async ({
  title,
  columns,
  data,
  fileName,
  disclaimer
}) => {
  try {

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(title);

    // Top Header
    worksheet.mergeCells(1, 1, 1, columns.length);

    const header = worksheet.getCell("A1");
    header.value = title;
    header.font = { bold: true, size: 16 };
    header.alignment = { horizontal: "center", vertical: "middle" };

    // Columns
    worksheet.columns = columns.map(col => ({
      key: col.key,
      width: col.width || 20
    }));

    // Column Header Row
    const headerRow = worksheet.getRow(2);
    headerRow.values = columns.map(col => col.header);
    headerRow.font = { bold: true };

    headerRow.eachCell((cell) => {
      cell.alignment = { horizontal: "center" };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });

    // Add Data
    data.forEach((item) => {

      const rowData = {};

      columns.forEach(col => {
        rowData[col.key] =
          typeof col.format === "function"
            ? col.format(item[col.key], item)
            : item[col.key];
      });

      const row = worksheet.addRow(rowData);

      row.eachCell((cell, colNumber) => {
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };

        if (colNumber > 1) {
          cell.alignment = { horizontal: "right" };
        }
      });

    });

    // Disclaimer
    if (disclaimer) {

      const lastRowNumber = worksheet.lastRow.number + 2;

      worksheet.mergeCells(
        lastRowNumber,
        1,
        lastRowNumber,
        columns.length
      );

      const disclaimerCell = worksheet.getCell(`A${lastRowNumber}`);

      disclaimerCell.value = disclaimer;

      disclaimerCell.font = { italic: true, size: 12 };

      disclaimerCell.alignment = {
        horizontal: "left",
        vertical: "top",
        wrapText: true,
      };

      worksheet.getRow(lastRowNumber).height = 110;

    }

    const buffer = await workbook.xlsx.writeBuffer();

    saveAs(
      new Blob([buffer]),
      `${fileName}.xlsx`
    );

  } catch (error) {
    console.error("Excel Export Error:", error);
  }
};

